import React from "react";
import "./Imagezoom.css";

function ImageZoomModal({ isOpen, onRequestClose, src, alt }) {
  if (!isOpen) {
    return null;
  }

  const handleImageClick = (e) => {
    if (e.target.classList.contains("close-icon")) {
      onRequestClose();
    }
  };

  return (
    <div className="image-zoom-modal" onClick={handleImageClick}>
      <div className="image-container">
        <span className="close-icon" onClick={onRequestClose}>X</span>
        <img src={src} alt={alt} />
      </div>
    </div>
  );
}

export default ImageZoomModal;
